import { enHeader } from '../en';
import { frHeader } from '../fr';
import { esHeader } from '../es';
import { deHeader } from '../de';

export const headerModuleTranslations = {
  en: enHeader,
  fr: frHeader,
  es: esHeader,
  de: deHeader,
} as const;

